import { render, staticRenderFns } from "./UploadEvidenceActionPlanDinamic.vue?vue&type=template&id=480d6bf2&"
import script from "./UploadEvidenceActionPlanDinamic.js?vue&type=script&lang=js&"
export * from "./UploadEvidenceActionPlanDinamic.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports